import { useEffect, useMemo, useState } from "react";
import Footer from "../components/home/Footer";
import Header from "../components/home/Header";
import MiniCart from "../components/home/MiniCart";
import SEOHead from "../components/seo/SEOHead";

export default function ContactThankYouPage() {
  const [scrolled, setScrolled] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems] = useState([]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const schema = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Thank You - Paras Organics",
    "url": "https://parasorganics.com/contact/thank-you"
  }), []);

  return (
    <>
      <SEOHead
        title="Thank You"
        description="Thank you for contacting Paras Organics. Our team will review your enquiry and get back to you soon."
        path="/contact/thank-you"
        schema={schema}
      />
      <Header scrolled={scrolled} cartItems={cartItems} onCartClick={() => setCartOpen((open) => !open)} />
      {cartOpen && <MiniCart cartItems={cartItems} onClose={() => setCartOpen(false)} />}
      <main className="thank-you-page">
        <section className="thank-you-shell" aria-labelledby="thank-you-title">
          <div className="thank-you-panel">
            <span className="section-label">Enquiry Received</span>
            <h1 className="thank-you-title" id="thank-you-title">Thank you for contacting Paras Organics</h1>
            <p>We have received your enquiry. Our team will review your requirement and respond shortly with the next steps.</p>
            <div className="thank-you-actions">
              <a className="btn-primary" href="/">Back to Home</a>
              <a className="btn-outline-green" href="/vermicompost">View Products</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
